// ModalActions.jsx

import React from 'react';

/**
 * ModalActions
 *
 * Renders a shared actions row wrapper for integrations modals.
 *
 * @param {ReactNode} children - Action buttons to render.
 *
 * @returns {ReactNode} The rendered actions row.
 */
const ModalActions = ({ children }) => {

    // ----- RENDER ----- //

    return <div className="api-integrations-actions">{children}</div>;
};

// Dev Tools
ModalActions.displayName = 'ModalActions';

export default ModalActions;
